import React, { Fragment } from "react";
import { Button, Row, Col, Alert } from "react-bootstrap";
import { getDateFormat } from "../common";

const StudentForm = ({ student }) => {
  return (
    <Fragment>
      <Alert variant="info">
        <Row>
          <Col>
            {student.displayName} - {student.username}
          </Col>
        </Row>
      </Alert>
    </Fragment>
  );
};

const CourseForm = ({ info }) => {
  return (
    <Fragment>
      <Alert variant="info">
        <Row>
          <Col>{info.courseNumber}</Col>
          <Col>{info.courseName}</Col>
          <Col>{info.classRoom}</Col>
          <Col>{info.classHour} 시</Col>
        </Row>
      </Alert>
    </Fragment>
  );
};

const WeekForm = ({ weekNumber, teamName, quests, handleRemove }) => {
  return (
    <Fragment>
      <Row className="p-2 align-items-center">
        <Col className="col-1">{weekNumber}주</Col>
        <Col className="col-2">{teamName ?? "팀 없음"}</Col>
        <Col>
          {quests.length > 0
            ? quests.map((it, index) => {
                return (
                  <Row key={index} style={{ textalign: "center" }}>
                    <Col>{it.number}</Col>
                    <Col>{it.buildingName}</Col>
                    <Col>
                      {it.completedAt
                        ? `완료 ${getDateFormat(it.completedAt)}`
                        : `미정`}
                    </Col>
                    <Col>
                      <Button
                        onClick={handleRemove}
                        name={"completeQuest"}
                        id={it.completedId}
                        value={weekNumber}
                        className="mb-2"
                        disabled={!it.completedAt}
                      >
                        완료 제거
                      </Button>
                    </Col>
                    {quests.length - 1 !== index ? <hr /> : undefined}
                  </Row>
                );
              })
            : "완료한 퀘스트가 없습니다."}
        </Col>
      </Row>
    </Fragment>
  );
};

export const StudentDetailForm = ({ student, handleRemove }) => {
  return (
    <Fragment>
      <StudentForm student={student.student} />
      <Fragment>
        {student.course ? (
          <Fragment>
            <CourseForm info={student.course.info} />
            {student.weeks.map((it, index) => {
              return (
                <Fragment key={index}>
                  <div key={index}>
                    <WeekForm
                      weekNumber={it.weekNumber}
                      teamName={it.teamName}
                      quests={it.quests}
                      handleRemove={handleRemove}
                    />
                  </div>
                  <hr />
                </Fragment>
              );
            })}
          </Fragment>
        ) : (
          <Fragment>
            <div>수업이 설정되지 않아서 주차별 정보가 존재하지 않습니다.</div>
          </Fragment>
        )}
      </Fragment>
    </Fragment>
  );
};
